<template>
    <div>
        <breadcrumb :routerList="[{to:'/xuqiu/Lmanagement',title:'需求管理'},{title:'转化需求'}]"/>
        <div class="h-content">
            <div class="h-row h-mrt0">
                <div class="h-rowIn">
                    <div class="h-rowBox">
                        <div class="h-rowCon">
                            <div class="h-pieceIn2">
                                <!-- <div style="height:30px;color:#303030;font-size:0.18rem;margin-bottom:20px;border-bottom:1px solid #dadfe0;font-weight:600">新增需求</div> -->
                                <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                    <h1>需求信息</h1>
                                </div>
                                <div class="h-pieceCon2">
                                    <div class="h-formLine weekplandetail20">
                                        <el-form :model="zy" label-position="right" ref="zy" :rules="rules"
                                                 :inline="true" class="demo-ruleForm h-formbLine h-formbLine1">
                                            <el-form-item label="客户全称" class="h-elformWrap-2" prop="euName">
                                                <el-input v-model="zy.euName" :v="zy.euName" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="需求分类" class="h-elformWrap-2" prop="formCon4">
                                                <el-input value="订单需求" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="区域" class="h-elformWrap-2" prop="areaCode"
                                                          v-if="customer.areaCode">
                                                <el-input v-model="customer.areaCode" :v="customer.areaCode"
                                                          readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="渠道" class="h-elformWrap-2" prop="channelCode"
                                                          v-if="customer.channelCode">
                                                <el-input v-model="customer.channelCode"
                                                          readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="联系人" class="h-elformWrap-2" prop="contactuserName">
                                                <el-input v-model="zy.contactuserName" :v="zy.contactuserName"
                                                          placeholder="请输入"></el-input>
                                            </el-form-item>
                                            <el-form-item label="部门科室" class="h-elformWrap-2" prop="department">
                                                <el-input v-model="zy.department" :v="zy.department"
                                                          placeholder="请输入"></el-input>
                                            </el-form-item>
                                            <el-form-item label="联系方式" class="h-elformWrap-2" prop="telephone">
                                                <el-input v-model="zy.telephone" :v="zy.telephone"
                                                          placeholder="请输入"></el-input>
                                            </el-form-item>
                                            <el-form-item label="预计投标日期" class="h-elformWrap-2" prop="bidConvDate">
                                                <el-date-picker
                                                        type="date"
                                                        placeholder="选择时间"
                                                        value-format="yyyy-MM-dd"
                                                        v-model="zy.bidConvDate"
                                                        :picker-options="pickerOptions">
                                                </el-date-picker>
                                            </el-form-item>
                                            <el-form-item label="预计成单日期" class="h-elformWrap-2" prop="expConvDate">
                                                <el-date-picker
                                                        type="date"
                                                        placeholder="选择时间"
                                                        value-format="yyyy-MM-dd"
                                                        v-model="zy.expConvDate"
                                                        :picker-options="pickerOptions">
                                                </el-date-picker>
                                            </el-form-item>
                                            <el-form-item label="中标概率" class="h-elformWrap-2" prop="bidPercentage">
                                                <el-select v-model="zy.bidPercentage" placeholder="请选择">
                                                    <el-option label="0%" value="0"></el-option>
                                                    <el-option label="30%" value="30"></el-option>
                                                    <el-option label="50%" value="50"></el-option>
                                                    <el-option label="80%" value="80"></el-option>
                                                    <el-option label="100%" value="100"></el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="需求说明" class="h-elformWrap-1" prop="content">
                                                <el-input v-model="zy.content" maxlength="70"
                                                          placeholder="请填写"></el-input>
                                            </el-form-item>
                                        </el-form>
                                    </div>
                                </div>
                            </div>
                            <div class="h-pieceIn2">
                                <!-- <div style="height:30px;color:#303030;font-size:0.18rem;margin-bottom:20px;border-bottom:1px solid #dadfe0;font-weight:600">新增需求</div> -->
                                <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                    <h1>用户在用产品信息</h1>
                                </div>
                                <div class="h-pieceCon2 yxtable">
                                    <div class="h-formLine weekplandetail20" style="margin-bottom:50px;">
                                        <div class="categoryBox">
                                            <div class="category" :class="{'active':item==categorys}"
                                                 @click="selectC(item)" v-for="(item,index) in category"
                                                 :key="index">{{item}}
                                            </div>
                                        </div>
                                        <div v-if="categorys == '海尔产品'" style="margin-top:20px;">
                                            <el-table
                                                    ref="multipleTable"
                                                    :data="productInfosHaier"
                                                    :border="true"
                                                    style="width: 100%"
													border
                                            >
                                                <el-table-column
                                                        type="index"
                                                        width="40"
                                                        label="#">
                                                </el-table-column>
                                                <el-table-column
                                                        prop="category"
                                                        label="产品大类"
                                                        width="200">
                                                    <template scope="scope">
                                                        <el-select v-model="scope.row.category"
                                                                   placeholder="请先选择产品大类"
                                                                   filterable
                                                                   @change="changeBigHaierBig(scope.row,scope.$index)"
                                                                   class="h-tableInput"
                                                        >
                                                            <el-option
                                                                    v-for="(item,index) in optionsProductBig"
                                                                    :key="index"
                                                                    :label="item.levelname"
                                                                    :value="item.id">
                                                            </el-option>
                                                        </el-select>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                        prop="specification"
                                                        label="产品型号"
                                                        width="250">
                                                    <template scope="scope">
                                                        <el-select v-model="scope.row.specification"
                                                                   placeholder="请先选择产品型号"
                                                                   filterable
                                                                   class="h-tableInput"
                                                        >
                                                            <el-option
                                                                    v-for="(item,index2) in optionsProductHaier[scope.$index]"
                                                                    :key="index2"
                                                                    :label="item.levelname"
                                                                    :value="item.id">
                                                            </el-option>
                                                        </el-select>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                        prop="amount"
                                                        label="产品数量"
                                                        width="100">
                                                    <template scope="scope">
                                                        <el-input v-model="scope.row.amount" class="h-tableInput"
                                                                  placeholder="请输入"></el-input>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                        prop="barCode"
                                                        label="条形码"
                                                        width="150">
                                                    <template scope="scope">
                                                        <el-input v-model="scope.row.barCode" class="h-tableInput"
                                                                  placeholder="请输入"></el-input>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                        prop="isOverdue"
                                                        label="是否超限期使用"
                                                        width="250">
                                                    <template scope="scope">
                                                        <brselect category="isOverdue" class="h-tableInput"
                                                                  :v="scope.row.isOverdue" v-model="scope.row.isOverdue"
                                                                  placeholder="--请选择--"></brselect>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                        prop="exfactoryDate"
                                                        label="出厂日期"
                                                        width="250">
                                                    <template scope="scope">
                                                        <div class="block">
                                                            <el-date-picker
                                                                    @change="beginDate(scope.row)"
                                                                    v-model="scope.row.exfactoryDate"
                                                                    type="date"
                                                                    placeholder="--选择--"
                                                                    value-format="yyyy-MM-dd"
                                                                    class="h-tableInput"
                                                                    :clearable=false>
                                                            </el-date-picker>
                                                        </div>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                        prop="purchaseDate"
                                                        label="购买日期"
                                                        width="250">
                                                    <template scope="scope">
                                                        <div class="block">
                                                            <el-date-picker
                                                                    @change="processDate(scope.row)"
                                                                    v-model="scope.row.purchaseDate"
                                                                    type="date"
                                                                    placeholder="--选择--"
                                                                    value-format="yyyy-MM-dd"
                                                                    class="h-tableInput"
                                                                    :clearable=false>
                                                            </el-date-picker>
                                                        </div>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                        label="产品照片"
                                                        width="150">
                                                    <template slot-scope="scope">
                                                        <brupload
                                                                :refid=scope.row.id
                                                                :reftype=jingpinHaier
                                                                :showtime="showtime"
                                                                uploadflag
                                                                delflag
                                                        >
                                                            <el-button size="small" type="text">上传</el-button>
                                                        </brupload>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                        prop="remark"
                                                        label="备注"
                                                        min-width="300">
                                                    <template scope="scope">
                                                        <el-input class="h-tableInput" v-model="scope.row.remark"
                                                                  placeholder="请输入"></el-input>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                        label="操作"
                                                        fixed="right"
                                                        width="100">
                                                    <template slot-scope="scope">
                                                        <el-button type="text" size="small"
                                                                   @click="delUserProduction1(scope.$index)">删除
                                                        </el-button>
														<!-- <div class="l-operationBox">
															<span class="l-operationlist br-operation-delete" title="删除该条" @click="delUserProduction1(scope.$index)"></span>
														</div> -->
                                                    </template>
                                                </el-table-column>
                                            </el-table>
                                            <div class="h-tableAdd" @click="addHaier">
                                                <a>新增在用海尔产品</a>
                                            </div>
                                        </div>
                                        <div v-if="categorys == '竞品'" style="margin-top:20px;">
                                            <el-table
                                                    ref="multipleTable"
                                                    :data="productInfosOther"
                                                    :border="true"
                                                    style="width: 100%"
													border
                                            >
                                                <el-table-column
                                                        type="index"
                                                        width="40"
                                                        label="#">
                                                </el-table-column>
                                                <el-table-column
                                                        prop="category"
                                                        label="产品大类"
                                                        width="200">
                                                    <template scope="scope">
                                                        <el-select v-model="scope.row.category"
                                                                   placeholder="请先选择产品大类"
                                                                   filterable
                                                                   class="h-tableInput"
                                                        >
                                                            <el-option
                                                                    v-for="(item,index) in optionsProductBig"
                                                                    :key="index"
                                                                    :label="item.levelname"
                                                                    :value="item.id">
                                                            </el-option>
                                                        </el-select>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                        prop="specification"
                                                        label="产品型号"
                                                        width="250">
                                                    <template scope="scope">
                                                        <el-input v-model="scope.row.specification" class="h-tableInput"
                                                                  placeholder="请填写产品型号"></el-input>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                        prop="amount"
                                                        label="产品数量"
                                                        width="100">
                                                    <template scope="scope">
                                                        <el-input v-model="scope.row.amount" class="h-tableInput"
                                                                  placeholder="请输入"></el-input>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                        prop="barCode"
                                                        label="条形码"
                                                        width="250">
                                                    <template scope="scope">
                                                        <el-input v-model="scope.row.barCode" class="h-tableInput"
                                                                  placeholder="请填写产品数量"></el-input>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                        prop="isOverdue"
                                                        label="是否超限期使用"
                                                        width="150">
                                                    <template scope="scope">
                                                        <brselect category="isOverdue" class="h-tableInput"
                                                                  :v="scope.row.isOverdue" v-model="scope.row.isOverdue"
                                                                  placeholder="--请选择--"></brselect>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                        prop="exfactoryDate"
                                                        label="出厂日期"
                                                        width="250">
                                                    <template scope="scope">
                                                        <div class="block">
                                                            <el-date-picker
                                                                    @change="beginDate(scope.row)"
                                                                    v-model="scope.row.exfactoryDate"
                                                                    type="date"
                                                                    class="h-tableInput"
                                                                    placeholder="--选择--"
                                                                    value-format="yyyy-MM-dd"
                                                                    :clearable=false>
                                                            </el-date-picker>
                                                        </div>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                        prop="purchaseDate"
                                                        label="购买日期"
                                                        width="250">
                                                    <template scope="scope">
                                                        <div class="block">
                                                            <el-date-picker
                                                                    @change="processDate(scope.row)"
                                                                    v-model="scope.row.purchaseDate"
                                                                    class="h-tableInput"
                                                                    type="date"
                                                                    placeholder="--选择--"
                                                                    value-format="yyyy-MM-dd"
                                                                    :clearable=false>
                                                            </el-date-picker>
                                                        </div>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                        label="产品照片"
                                                        width="150">
                                                    <template slot-scope="scope">
                                                        <brupload
                                                                :refid=scope.row.id
                                                                :reftype=jingpinOther
                                                                :showtime="showtime"
                                                                uploadflag
                                                                delflag
                                                        >
                                                            <el-button size="small" type="text">上传</el-button>
                                                        </brupload>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                        prop="remark"
                                                        label="备注"
                                                        min-width="300">
                                                    <template scope="scope">
                                                        <el-input v-model="scope.row.remark" class="h-tableInput"
                                                                  placeholder="请输入"></el-input>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                        label="操作"
                                                        fixed="right"
                                                        width="100">
                                                    <template slot-scope="scope">
                                                       <el-button type="text" size="small"
                                                                   @click="delUserProduction2(scope.$index)">删除
                                                        </el-button>
														<!-- <div class="l-operationBox">
															<span class="l-operationlist br-operation-delete" title="删除该条" @click="delUserProduction2(scope.$index)"></span>
														</div> -->
                                                    </template>
                                                </el-table-column>
                                            </el-table>
                                            <div class="h-tableAdd" @click="addComp">
                                                <a>新增在用竞品产品</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="h-pieceIn2">
                                <!-- <div style="height:30px;color:#303030;font-size:0.18rem;margin-bottom:20px;border-bottom:1px solid #dadfe0;font-weight:600">新增需求</div> -->
                                <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                    <h1>信息获取</h1>
                                </div>
                                <div class="h-pieceCon2">
                                    <div class="h-formLine weekplandetail20">
                                        <el-form :model="detail" label-position="right" ref="zy" :rules="rules"
                                                 :inline="true" class="demo-ruleForm h-formbLine h-formbLine1">
                                            <el-form-item label="产品大类" class="h-elformWrap-2" prop="proCode">
                                                <el-select v-model="detail.proCode" placeholder="请选择"
                                                           @change="showproModel(detail.proCode)">
                                                    <el-option v-for="(item) in LevelName"
                                                               :key="item.id"
                                                               :label="item.levelname"
                                                               :value="item.id">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="产品型号" class="h-elformWrap-2" prop="proModel">
                                                <el-select v-model="detail.proModel"
                                                           placeholder="请选择">
                                                    <el-option v-for="(item) in ProModel"
                                                               :key="item.id"
                                                               :label="item.levelname"
                                                               :value="item.id">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="产品数量" class="h-elformWrap-2" prop="proNumber">
                                                <el-input v-model="detail.proNumber" :v="detail.proNumber"
                                                          @change="totalprice"
                                                          placeholder="请输入正整数"
                                                          oninput="value=value.replace(/[^\d]/g, '')"></el-input>
                                            </el-form-item>
                                            <el-form-item label=产品单价 class="h-elformWrap-2" prop="proPrice">
                                                <el-input v-model="detail.proPrice" :v="detail.proPrice"
                                                          placeholder="请输入" @change="totalprice"
                                                ></el-input>
                                            </el-form-item>
                                            <el-form-item label="总计" class="h-elformWrap-2" prop="proTotalAmount">
                                                <el-input v-model="detail.proTotalAmount"
                                                          :v="detail.proTotalAmount" readonly></el-input>
                                            </el-form-item>
                                        </el-form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="h-txtCenter h-mrt60">
                <el-button class="h-btn h-bBtn h-bgwhite" @click="backS">返回</el-button>
                <!-- <el-button class="h-btn h-bBtn h-bggreen" @click="zanCun">暂存</el-button>-->
                <el-button class="h-btn h-bBtn h-bgblueQ2" @click="refer">确认提交</el-button>
            </div>
        </div>
    </div>
</template>

<script>
    import ss from '../../api/SystemService'

    export default {
        data() {
            return {
                LevelName: [],
                ProModel: [],
                //带线表单
                value: false,
                categorys: '海尔产品',
                category: ['海尔产品', '竞品'],
                showtime: false,
                jingpinOther: "竞品信息-其他品牌",
                jingpinHaier: "竞品信息-海尔",
                optionsCustomer: [],
                //产品大类选项
                optionsProduct1: [],
                //产品小类选项
                optionsProduct2: [],
                //产品大类选项
                optionsProductBig: [],
                //产品小类选项
                optionsProductHaier: [{}],
                //海尔产品竞品
                productInfosHaier: [{type: "1", fromType: '31',specification:'',id: this.getUUid()}],
                //其他品牌产品竞品
                productInfosOther: [{type: "2", fromType: '31',id: this.getUUid()}],
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 24 * 60 * 60 * 1000
                    }
                },
                zy: {
                    euName: '',
                    cid: '',
                    euCode: null,
                    content: null,
                    levelname: null,
                    productInfoList: [],
                    detail: {
                        proCode: '',
                        proModel: '',
                        proNumber: '',
                        proTotalAmount: '',
                    },
                    contactuserName: null,
                    department: null,
                    telephone: null,
                },
                customer: {
                    areaCode: null,
                    channelCode: null,

                },
                detail: {
                    proCode: '',
                    proModel: '',
                    proNumber: '',
                    proTotalAmount: '',
                },
                rules: {
                    euName: [{required: true, message: '请选择客户全称', trigger: 'blur'}],
                    department: [{required: true, message: '请填写部门/科室', trigger: 'blur'}],
                    contactuserName: [{required: true, message: '请填写联系人', trigger: 'blur'}],
                    telephone: [{required: true, message: '请填写联系电话', trigger: 'blur'}],
                    proCode: [{required: true, message: '请选择产品大类', trigger: 'blur'}],
                    proModel: [{required: true, message: '请选择产品型号', trigger: 'blur'}],
                    proNumber: [{required: true, message: '请填写需求数量', trigger: 'blur'}],
                    proPrice: [
                        {required: true, message: '请填写产品单价', trigger: 'blur'},
                        { validator: (rule, value, callback) => {
                                if (/^\d+.\d+$/.test(value) == false) {
                                    callback(new Error("只能写浮点数"));
                                } else {
                                    callback();
                                }
                            },trigger: 'change'
                        }
                    ],
                    content: [
                        {required: true, message: '请输入需求说明', trigger: 'blur'}
                    ],
                }
            }
        },
        created() {
            this.query();
            this.showLevelName();

        },
        mounted() {
            //竞品使用
            this.selectProductBig();
            this.selectComperOption();
        },
        methods: {
            getUUid() {
                return  this.$util.getUuid();
            },
            totalprice(){
                if(this.detail.proNumber!=null && this.detail.proPrice!=null) {
                    this.detail.proTotalAmount = this.detail.proNumber * this.detail.proPrice;
                }
            },
            //返回交互计划页面
            backS() {
                this.$router.go(-1);
            },
            //产品大类
            showLevelName() {
                ss.UserDemand.showLevelName().then(rd => {
                    this.LevelName = rd;
                })
            },
            showproModel(value) {
                this.detail.proModel = '';
                ss.UserDemand.showproModel(value).then(rd => {
                    this.ProModel = rd;
                })
            },
            query() {
                this.zy.cid = this.$route.query.id;
                ss.UserDemand.showUserCare(this.zy.cid).then(rd => {
                    this.zy.euCode = rd.obj.euCode;
                    this.zy.euName = rd.obj.euName;
                    this.zy.euType = rd.obj.euType;
                    this.customer.areaCode = this.$getDictName("YLRegion", rd.obj.areaCode);
                    this.customer.channelCode = this.$getDictName("sales_region", rd.obj.channelCode);
                    this.zy.contactuserName = rd.obj.contact;
                    this.zy.department = rd.obj.contactDept;
                    this.zy.telephone = rd.obj.contactPhone;
                })

            },
            refer() {
                var subflag = false;
                this.$refs['zy'].validate((valid) => {
                    if (valid) {
                        subflag = true;
                    } else {
                        this.$msg.msge("请完善信息后再提交！");
                        return false;
                    }
                });
                if (subflag == true) {
                    this.zy.productInfoList=[];
                    for (var i = 0; i < this.productInfosHaier.length; i++) {
                        if (this.productInfosHaier[i].category != null && this.productInfosHaier[i].specification != null) {
                            this.zy.productInfoList.push(this.productInfosHaier[i]);
                        }
                    }
                    for (var i = 0; i < this.productInfosOther.length; i++) {
                        if (this.productInfosOther[i].category != null && this.productInfosOther[i].specification != null) {
                            this.zy.productInfoList.push(this.productInfosOther[i]);
                        }
                    }
                    if (this.zy.euType == 0) {
                        this.zy.euType = 2;
                    }
                    this.zy.detail = this.detail;
                    ss.UserDemand.savedd(this.zy).then(rd => {
                        this.$msg.msgs("操作成功");
                        this.$router.push("/xuqiu/Lmanagement");

                    });
                }
            },
            selectC(item) {
                this.categorys = item;
            },
            delUserProduction1(index) {
                this.productInfosHaier.splice(index, 1)
            },
            delUserProduction2(index) {
                this.productInfosOther.splice(index, 1)
            },
            addComp() {
                var a = {type: 2, fromType: 31,id: this.getUUid()}
                this.productInfosOther.push(a)
            },
            addHaier() {
                var a = {type: 1, fromType: 31, specification: '', brand: "Haier",id: this.getUUid()}
                this.productInfosHaier.push(a)
            },
            selectComperOption() {
                ss.ProService.comperOption({}).then(rd => {
                    console.log("品牌大类下拉", rd)
                    this.comperOption = rd;
                })
            },
            //品牌名称保存
            getBrandName(v, i) {
                var sup = _.filter(this.comperOption, {'id': v.brand});
                v.brandName = sup[0].brandName;
            },
            //大类修改时，当块数据proProduct[i]-v,index-i
            changeBigHaierBig(v, i) {
                v.specification = '';
                this.selectProductHaier(v.category, i);
            },
            //海尔内部竞品，大类修改时，查询小类列表 v.type大类id-v,index-i
            selectProductHaier(v, i) {
                //console.log("3选中大类222",v,i);
                ss.ProService.product2Select(v).then(rd => {
                    //console.log("4产品小类下拉", rd)
                    this.optionsProductHaier[i] = rd;
                    this.$set(this.optionsProductHaier, i, rd);
                    //console.log(this.optionsProductHaier[i],"5产品小类下拉", this.optionsProductHaier)
                })
            },
            selectProductBig() {
                ss.ProService.product1Select().then(rd => {
                  //  console.log("产品大类下拉", rd)
                    this.optionsProductBig = rd;
                })
            },
            //时间限制
            beginDate(v) {
                if (v.purchaseDate) {  //如果结束时间不为空，则小于结束时间
                    console.log(v, v.purchaseDate, v.exfactoryDate);
                    if (v.purchaseDate < v.exfactoryDate) {
                        this.$msg.msge("购买日期不能小于出厂日期");
                        v.exfactoryDate = "";
                    }
                }
            },
            processDate(v) {
                if (v.exfactoryDate) {//如果有出厂日期
                    //如果购买日期小于出厂日期
                   // console.log(v, v.purchaseDate, v.exfactoryDate);
                    if (v.purchaseDate < v.exfactoryDate) {
                        this.$msg.msge("购买日期不能小于出厂日期");
                        v.purchaseDate = "";
                    }
                }
            }
        }
    }
</script>

<style scoped>
    .categoryBox {
        display: flex;
        border-bottom: 1px solid #dcdfe1;
    }

    .categoryBox .category {
        width: 122px;
        height: 36px;
        color: #b0b0b0;
        font-size: 0.2rem;
        text-align: center;
        line-height: 36px;
        margin-left: 20px;
        border: 1px solid #b4b4b4;
        cursor: pointer;
        border-bottom: 0;
    }

    .categoryBox .category:first-child {
        margin-left: 0;
    }

    .categoryBox .category.active {
        color: #fff;
        border: 1px solid #0e75e9;
        background: #0e75e9;
    }
</style>
<style>
    .weekplandetail20 .h-formbLine .el-form-item__label {
        width: 31%;
        text-align: right;
    }

    .weekplandetail20 .h-formbLine .el-form-item__content {
        width: 69%;
    }

    .weekplandetail20 .h-formbLine .h-elformWrap-2 {
        width: 33.333%;
        padding-right: 0.5rem
    }

    .weekplandetail20 .h-formbLine .h-elformWrap-1 {
        width: 100%;
        padding-right: 0.5rem
    }

    .weekplandetail20 .h-formbLine .h-elformWrap-1 .el-form-item__label {
        width: 9.7%;
    }

    .weekplandetail20 .h-formbLine .h-elformWrap-1 .el-form-item__content {
        width: 90.3%;
    }

    .yxtable .el-table tbody td .cell {
        padding: 0;
    }
</style>
